module.exports = __webpack_public_path__ + "static/particle-2-4bff2f5f2a4906a6f9a18a1f5a688ac5.png";